import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import LabellessDateField from 'Components/ComponentLibrary/Components/Uncategorized/LabellessDateField';
import LabellessSelectField from 'Components/ComponentLibrary/Components/Uncategorized/LabellessSelectField';
import LabellessTextField from 'Components/ComponentLibrary/Components/Uncategorized/LabellessTextField';
import { NumberFormatUsd } from 'Components/UI/MaskedInput';
import { FDBodyText } from '@facet-wealth/design';
import Text from 'Components/ComponentLibrary/Atoms/Text';

export const RecurringExpenseItemOverride = buildFacetDesignOverride()
  .nameOverride('value', {
    _component: () => LabellessTextField,
    showHelperTextOnInlineSubmit: false,
    _customProps: {
      InputProps: {
        inputComponent: NumberFormatUsd,
      },
    },
  }, overrideReadOnly)
  .nameOverride('frequency', {
    _component: () => LabellessSelectField,
    _customHelperProps: {
      showHelperTextOnInlineSubmit: false,
    },
    _customProps: {
    },
  }, overrideReadOnly)
  .nameOverride('frequencyDescriptor', {
    _component: () => FDBodyText,
    _customProps: {
      size: 'sm',
      color: 'textDisabled',
    },
  }, overrideReadOnly)
  .override({ name: 'title', readonly: false }, {
    _component: () => LabellessTextField,
    showHelperTextOnInlineSubmit: false,
    placeholder: 'Name your expense...',
    _customProps: {
    },
  }, overrideReadOnly)
  .override({ name: 'title', readonly: true }, {
    _component: () => Text,
    _customProps: {
      variant: 'h5',
      color: 'black',
      weight: 'medium',
      align: 'left',
    },
  }, overrideReadOnly)
  .nameOverride('nextPaymentDate', {
    _component: () => LabellessDateField,
    _customHelperProps: {
      showHelperTextOnInlineSubmit: false,
    },
    placeholder: 'Select date',
    _customProps: {
      format: 'MMM YYYY',
    },
  }, overrideReadOnly);
